<template>
  <div
    class="modal nb-modal-mask"
    style="display:block; z-index: 1 !important;"
    @keyup.esc="closeModal()"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-lg"
      role="document"
      style="overflow-y: initial !important"
    >
      <div class="modal-content">
        <div
          class="modal-body pt-3"
          style="height: 70vh!important ;max-height: 100%; overflow-y: auto"
        >
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Informar Cliente</strong>
          </div>
          <button @click="closeModal" class="close">
            <span>&times;</span>
          </button>
          <div class="row nb-margin-bottom" v-if="!localPart">
            <div class="col-md-12 col-12">
              <span class="vd-text-supplementary"
                >Selecione um cliente (F4)</span
              >
            </div>
            <div class="col-md-12 col-12">
              <input-part
                v-if="!localPart"
                ref="part"
                v-model="codpart"
                :add-button="true"
                :varejo="true"
                @change="handleSetCodpart()"
              ></input-part>
            </div>
          </div>

          <!-- CLIENTE SELECIONADO - EXIBE INFORMACOES DE CRÉDITO -->
          <div class="border" style="padding: 10px;" v-if="localPart">
            <div class="row">
              <div class="col">
                <span class="lbl-title-produto decrase-lbl-title">{{
                  localPart.nome
                }}</span
                ><br />
                <span class="data-list decrase-lbl-title">{{
                  localPart.cnpjcpf | formatCNPJCPF
                }}</span
                ><br />
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <v-button
                  class="float-right"
                  ref="btnPart"
                  title="Excluir"
                  icon="fa-trash"
                  @click="handleDeleteCliente"
                ></v-button>
                <v-button
                  class="float-right"
                  title="Trocar Cliente"
                  icon="fa-refresh"
                  @click="handleAlteraCliente"
                ></v-button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="handleConfirm()">
            Confirmar
          </button>
          <button class="btn btn-secondary" @click="closeModal()">
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params_pdv: {
      type: Object,
      default: []
    },
    selectedPart: {
      type: Object,
      default: {}
    },
    client_editing: {
      type: Boolean,
      default: false
    },
    deletar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codpart: null,
      localPart: null,
    };
  },
  methods: {
    handleConfirm() {
      // this.$refs.part.handleNewCostumer();
      this.$emit("changeCodpart", this.codpart);
      this.closeModal();
    },
    handleSetCodpart(selected) {
      console.log(selected)
      // this.$emit("changeCodpart", this.codpart);
      // this.closeModal();
    },
    closeModal() {
      this.$emit("close");
    },
    handleDeleteCliente() {
      // this.$emit("changeCodpart", null);
      this.localPart = null;
      this.codpart = null;
      this.$nextTick(function() {
        this.$refs.part.focus();
      });
    },

    handleAlteraCliente() {
      //REMOVE O CLIENTE SELECIONADO E ABRE PARA INFORMAR NOVO CLIENTE
      this.handleDeleteCliente();
    }
  },
  created() {
    if (this.selectedPart)
      if (this.selectedPart.codpart || this.selectedPart.cnpjcpf) {
        this.localPart = {...this.selectedPart}
        if (this.selectedPart.codpart)
          this.codpart = this.localPart.codpart
        else
          this.codpart = this.localPart.cnpjcpf
      }
    this.$nextTick(function() {
      if (this.deletar) {
        this.handleDeleteCliente();
      }
      if (!this.localPart) {
        this.$refs.part.focus();
      } else {
        this.$refs.btnPart.focus();
      }
    });
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-cliente.vue